<template>
  <nav
    class="block xl:ml-28 lg:ml-16 md:ml-10 md:mt-20 md:sticky md:pt-10 md:top-10 h-full"
  >
    <div
      class="border-divider pt-2 pb-3"
      v-for="(section, index) in sections"
      :key="section.id"
      :class="{ 'border-t': index !== 0 }"
    >
    <button
    role="link"
      @click="openInNewTab('https://chrome.google.com/webstore/detail/jcalgimklilgldebopiighdhpgbmkmdi')"
    v-if="index==0" class="text-sm py-1 px-4 rounded-md font-bold bg-primary text-white hover:bg-primaryDark hover:border-outline focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-2">
       <b>Click to Install</b><br/><ion-icon name="download-sharp" class="text-1xl px-1"></ion-icon>Sappy React
        </button>
        <div class="border-divider pt-2 pb-3" v-if="index==0"></div>
      <h1
        v-if="section.title"
        class="font-semibold text-subtitle ml-2 pb-2 text-sm cursor-default"
      >
        {{ section.title }}
      </h1>
      <button
        class="flex items-center gap-2 rounded-md px-3 py-1 w-full whitespace-nowrap"
        :class="{
          'font-bold bg-hover text-primary': button.isActive,
          'font-semibold text-foreground hover:bg-hover': !button.isActive,
          'cursor-default text-divider': !button.isEnabled,
        }"
        v-on:click="button.isEnabled ? setActive(button) : null"
        v-for="button in section.data"
        :key="button.id"
      >
        <ion-icon v-bind:name="button.icon" v-if="button.icon"></ion-icon>

        <span
          class="text-foreground"
          :class="{
            'text-primary': button.isActive,
            'text-subtitle': !button.isEnabled,
          }"
          >{{ button.name }}</span
        >
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      sections: [
        {
          data: [
            {
              id: 1,
              name: "Featured",
              icon: "sparkles",
              isActive: true,
              isEnabled: true,
            },
            {
              id: 2,
              name: "Browse",
              icon: "search-sharp",
              isActive: false,
              isEnabled: true,
            },
            { id: 3, name: "All Time", icon: "star", isActive: false },
          ],
        },
        {
          title: "Tools",
          data: [
            { id: 1, name: "Market 2 Earn", icon: "sparkles", isActive: false },
            { id: 2, name: "Create", icon: "pencil", isActive: false },
            { id: 3, name: "AI", icon: "hammer", isActive: false },
          ],
        },
        {
          title: "Community",
          data: [
            { id: 1, name: "Sappy Seals", isActive: false, isEnabled: true },
            { id: 2, name: "The Plague", isActive: false },
            { id: 3, name: "Pudgy Penguins", isActive: false },
            { id: 4, name: "y00ts", isActive: false },
            { id: 5, name: "Ape Society", isActive: false },
            { id: 6, name: "+ More", isActive: false },
          ],
        },
        {
          title: "Creators",
          data: [
            { id: 1, name: "Top", icon: "heart", isActive: false },
            {
              id: 2,
              name: "Leaderboard",
              icon: "podium-sharp",
              isActive: false,
            },
          ],
        },
      ],
    };
  },
  methods: {
    setActive(link) {
      this.sections.forEach((section) =>
        section.data.forEach((item) => (item.isActive = false))
      );
      link.isActive = true;
      this.$store.dispatch("ChangeActiveLink", link.name);
    },
    openInNewTab(url) {
      var win = window.open(url, "_blank");
      win.focus();
    },
  },
};
</script>
